import { Flex } from "antd";

const RequiredMark = (label, { required }) => {
    if (required) {

        return (
            <Flex>
                {label}
                {<span style={{ color: "red" }}>*</span>}
            </Flex>)
    } else {
        return label
    }
}

export default RequiredMark;